import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter, faFacebookF, faYoutube, faInstagram } from "@fortawesome/free-brands-svg-icons"
// import './layout.css'

const SocialLinks = {
    instagram: 'https://instagram.com/aura.djsce?igshid=wb2v3l0549dd',
    youtube: 'https://www.youtube.com/channel/UC_Cy6EmraiY5nV1Xyv2tPPw',
    twitter: 'https://twitter.com/aura_djsce',
    facebook: 'https://www.facebook.com/aura.djs/'
  };

const socialIconStyle = {
    // width: 40,
    // height: 40,
    marginRight: 10,
    cursor: 'pointer'
};

const handleSocialLinks = network => () => {
    window.open(SocialLinks[network]);
};

function Footer(props) {

    return (
        <footer id="footer" >
            <div id="footer-content" >
                <Grid container  >
                    <Hidden only={
                        [ 'md', 'lg', 'xl']} >

                        <Grid item xs={12}
                             >
                            <FontAwesomeIcon className="iconFooter"  
                            onClick={handleSocialLinks('twitter')} id="social-link"
                            style ={socialIconStyle} color="white"
                                icon={faTwitter}
                            />
                             <FontAwesomeIcon className="iconFooter" 
                             onClick={handleSocialLinks('youtube')} id="social-link"
                             style ={socialIconStyle} color="white"
                                icon={faYoutube}
                            />
                             <FontAwesomeIcon className="iconFooter"  
                             onClick={handleSocialLinks('instagram')} id="social-link"
                             style ={socialIconStyle} color="white"
                                icon={faInstagram}
                            />
                             <FontAwesomeIcon className="iconFooter"  
                             onClick={handleSocialLinks('facebook')} id="social-link"
                             style ={socialIconStyle} color="white"
                                icon={faFacebookF}
                            />
                            </Grid> 
                            </Hidden>

                </Grid> <
                    br />

                <Grid container >
                    <Grid item xs={12}
                        className="copyrightsm" >
                        <Typography style={
                            { fontSize: '1.1rem', color:'#fffb' }} >
                            Made with <span role="img" aria-label='heart'>❤️</span> by Team AURA </Typography> <Typography variant="body1"
                                style={
                                    { fontWeight: '600',color:'goldenrod' }} >
                            AURA KAYAM RAHE
        </Typography>
                    </Grid>
                </Grid>
            </div>
        </footer>
    );
}

Footer.defaultProps = {
    contactUsPagePath: '',
    practiceFormPath: '',
    questionBankPagePath: '',
    faqPagePath: ''
};

Footer.propTypes = {
    contactUsPagePath: PropTypes.string,
    practiceFormPath: PropTypes.string,
    questionBankPagePath: PropTypes.string,
    faqPagePath: PropTypes.string
};

export default Footer;